import e from"./HierarchicalMenu.vue_vue&type=script&lang.js";import{render as r}from"./HierarchicalMenu.vue_vue&type=template&id=15099ac6&lang.js";e.render=r;export default e;
//# sourceMappingURL=HierarchicalMenu.vue.js.map
